import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIClient } from "src/app/core/api-client/contracts/api-client.service";
import { ICustomerRss } from "src/app/shared/models/ICustomer-rss";
import { IFacility } from "src/app/shared/models/IFacility";
import { IFacilityRss } from "src/app/shared/models/IFacility-rss";
import { IPrefixSuffixFacility } from "src/app/shared/models/IPrefixSuffixFacility";
import { ICountry, IState } from "src/app/shared/models/lookup.model";

@Injectable({
    providedIn: 'root'
})
export class FacilitiesService {

    resource = 'facility';
    constructor(private client: APIClient) { }

    getFacilities(): Observable<IFacility[]> {
        return this.client.get<any>(`${this.resource}/getAllFacilities`);
    }
    getFacilitiesByIdnId(idnId: number): Observable<IPrefixSuffixFacility[]> {
        return this.client.get<IPrefixSuffixFacility[]>(`${this.resource}/getFacilitiesByIdnId/${idnId}`)
    }
    createFacility(facility: IFacility): Observable<IFacility> {
        return this.client.post<IFacility>(`${this.resource}`, facility);
    }

    getFacilityById(id: number): Observable<IFacility> {
        return this.client.get<IFacility>(`${this.resource}/${id}`)
    }

    getAllCountry(): Observable<ICountry[]> {
        return this.client.get<ICountry[]>(`${this.resource}/getAllCountry`);
    }

    getAllStatesByCountryId(id: number): Observable<IState[]> {
        return this.client.get<IState[]>(`${this.resource}/GetAllStatesByCountryId/${id}`);
    }
    
    getAllHybridIOCustomers(): Observable<ICustomerRss[]> {
        return this.client.get<ICustomerRss[]>(`${this.resource}/hybridio/getallhybridiocustomers`);
    }

    getAllHybridIOFacilitiesByCustomerId(customerId: string): Observable<IFacilityRss[]> {
        return this.client.get<IFacilityRss[]>(`${this.resource}/hybridio/${customerId}`);
    }
}